import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/theme.context';
import BusinessThemeBinder from './app/components/BusinessThemeBinder';
import ClientApp from './app/business/App';
import ClientAboutPage from './app/about/AboutPageV2';
import pageRoutes from './page.routes';
import ClientBranchesPage from './app/branches/BranchesPage';
import ClientBookingPage from './app/booking/BookingPage';
import ClientOrderDetailPage from './app/order/OrderDetailPage';
import ClientGiftSelectionPage from './app/gift/GiftSelectionPage';

function AppRoutes() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <BusinessThemeBinder />
        <Routes>
          <Route path="/" element={<ClientAboutPage />} />
          <Route path="/pages">
            {pageRoutes}
          </Route>
          <Route path="/privacy" element={<Navigate to="/pages/privacy" replace />} />
          <Route path="/:business/branches" element={<ClientBranchesPage />} />
          <Route path="/:business/branches/:branchId/booking" element={<ClientBookingPage />} />
          <Route path="/:business/orders/:orderId" element={<ClientOrderDetailPage />} />
          <Route path="/:business/promotions/:promotionId/gift" element={<ClientGiftSelectionPage />} />
          <Route path="/:business" element={<ClientApp />} />
          <Route path="*" element={<ClientAboutPage />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default AppRoutes;
